import { render, staticRenderFns } from "./CItem.vue?vue&type=template&id=7cfd09b1&"
import script from "./CItem.vue?vue&type=script&lang=js&"
export * from "./CItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports